// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"fad8d98e","689":"9ebc8f4b","954":"903d6ba1"}[chunkId] + ".chunk.js";
};